import { TemplatesService } from './templates.service';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.services.templates', [])
  .service('templatesService', TemplatesService).name;
